/* eslint-disable react-hooks/exhaustive-deps */
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import IconButton from "@mui/material/IconButton";
import useApiRequest from "utils/Apirequest";
import dayjs from "dayjs";
import Alert from "@mui/material/Alert";
import {
  isValidPhone,
  isValidDriverId,
  allowOnlyAlphanumericAndSpace,
} from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";

function PopAddReservation(props) {
  const apiRequest = useApiRequest();
  const [selectedDate] = useState(dayjs());
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const [isBackdrop] = useState(false);
  const { onClose } = props;

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErrors] = useState({});

  const createUser = async (tag_id, charger_id, connectorId, selectedDate) => {
    const payload = {
      idTag: tag_id,
      chargerId: charger_id,
      connectorId: connectorId,
      timezone: `${process.env.REACT_APP_TIMEZONE}`,
    };
    const { data } =
      (await apiRequest(
        "post",
        "reservations/",
        payload,
        {},
        { "Content-Type": "application/json" }
      )) || {};
    if (data?.status) {
      window.location.reload();
    }
  };

  const [values, setValues] = useState(props.value);
  const handleChange = (event) => {
    const { name, value } = event.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };


  const handleSubmit = (event) => {
    event.preventDefault();

    const validationErrors = validateReservation(values);

    // Always update UI first
    setErrors(validationErrors);

    // Hard stop if ANY error exists
    if (Object.keys(validationErrors).length > 0) {
      enqueueSnackbar("Please correct the highlighted errors", {
        variant: "error",
      });
      return;
    }

    // Safe to proceed
    createUser(
      values.tag_id.trim(),
      values.charger_id.trim(),
      Number(values.connectorId),
      selectedDate
    );
  };

  const handleClose = () => {
    onClose(false);
  };

  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
  }, []);
  const normalize = (val) =>
    typeof val === "string" ? val.trim() : val;

  const validateReservation = (values) => {
    const errors = {};

    const tagId = normalize(values.tag_id);
    const chargerId = normalize(values.charger_id);
    const connectorId = normalize(values.connectorId);

    // Mobile / Tag ID
    if (!tagId) {
      errors.tag_id = "Mobile Number / Tag ID is required";
    } else if (!isValidPhone(tagId) && !isValidDriverId(tagId)) {
      errors.tag_id = "Invalid Mobile Number / Tag ID";
    }

    // Charger Name / ID
    if (!chargerId) {
      errors.charger_id = "Charger Name / ID is required";
    } else if (!allowOnlyAlphanumericAndSpace(chargerId)) {
      errors.charger_id = "Invalid Charger Name / ID";
    }

    // Connector ID
    if (!connectorId) {
      errors.connectorId = "Connector ID is mandatory";
    } else if (!/^\d+$/.test(connectorId)) {
      errors.connectorId = "Connector ID must be numeric";
    } else {
      const num = Number(connectorId);
      if (num < 1 || num > 8) {
        errors.connectorId = "Connector ID must be between 1 and 8";
      }
    }

    return errors;
  };

  const validateField = (name, value, allValues) => {
    const errors = {};

    const normalized = typeof value === "string" ? value.trim() : value;

    if (name === "tag_id") {
      if (!normalized) {
        errors.tag_id = "Mobile Number / Tag ID is required";
      } else if (!isValidPhone(normalized) && !isValidDriverId(normalized)) {
        errors.tag_id = "Invalid Mobile Number / Tag ID";
      }
    }

    if (name === "charger_id") {
      if (!normalized) {
        errors.charger_id = "Charger Name / ID is required";
      } else if (!allowOnlyAlphanumericAndSpace(normalized)) {
        errors.charger_id = "Invalid Charger Name / ID";
      }
    }

    if (name === "connectorId") {
      if (!normalized) {
        errors.connectorId = "Connector ID is mandatory";
      } else if (!/^\d+$/.test(normalized)) {
        errors.connectorId = "Connector ID must be numeric";
      } else {
        const num = Number(normalized);
        if (num < 1 || num > 8) {
          errors.connectorId = "Connector ID must be between 1 and 8";
        }
      }
    }

    return errors;
  };



  return (
    <>
      <MDBackdrop isBackdrop={isBackdrop} />
      <Dialog
        open={props.isDialog}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
              : {
                theme,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
          }
        >
          <div style={{ margin: "auto" }}>Reserve a charging session</div>
          <IconButton
            aria-label="delete"
            onClick={handleClose}
            style={darkMode ? { color: "#ffffff" } : theme}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          style={
            darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme
          }
        >
          <MDBox pt={0} pb={0} px={3}>
            <MDBox pt={0}></MDBox>
            <MDBox p={2} component="form" role="form">
              <MDBox p={1}>
                <MDInput
                  label="Mobile number / Tag ID"
                  name="tag_id"
                  value={values.tag_id || ""}
                  fullWidth
                  onChange={handleChange}
                  onBlur={(e) => {
                    const fieldErrors = validateField("tag_id", e.target.value, values);
                    setErrors((prev) => ({ ...prev, ...fieldErrors }));
                  }}
                  error={!!errors.tag_id}
                  helperText={errors.tag_id}
                  FormHelperTextProps={{
                    sx: {
                      color: "#d32f2f",   // red
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />

              </MDBox>

              <MDBox p={1}>
                <MDInput
                  label="Charger name / ID"
                  name="charger_id"
                  value={values.charger_id || ""}
                  fullWidth
                  onChange={handleChange}
                  onBlur={(e) => {
                    const fieldErrors = validateField("charger_id", e.target.value, values);
                    setErrors((prev) => ({ ...prev, ...fieldErrors }));
                  }}
                  error={!!errors.charger_id}
                  helperText={errors.charger_id}
                  FormHelperTextProps={{
                    sx: {
                      color: "#d32f2f",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />

              </MDBox>
              <MDBox p={1}>
                <MDInput
                  label="Connector ID"
                  name="connectorId"
                  value={values.connectorId || ""}
                  fullWidth
                  onChange={handleChange}
                  onBlur={(e) => {
                    const fieldErrors = validateField("connectorId", e.target.value, values);
                    setErrors((prev) => ({ ...prev, ...fieldErrors }));
                  }}
                  error={!!errors.connectorId}
                  helperText={errors.connectorId}
                  inputProps={{ min: 1, max: 8 }}
                  FormHelperTextProps={{
                    sx: {
                      color: "#d32f2f",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />

              </MDBox>
              <MDBox p={1} style={{ display: "flex" }}>
                <Alert
                  sx={{
                    height: "42px",
                    width: "100%",
                    pt: 0.1,
                    pb: 0.5,
                    fontSize: "0.90rem",
                  }}
                  severity="warning"
                >
                  The reservation will be available for maximum 15 minutes
                </Alert>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                justifyContent: "space-evenly",
                color: "#ffffff",
              }
              : { theme, justifyContent: "space-evenly" }
          }
        >
          <MDButton
            style={{ width: "87%" }}
            variant="gradient"
            color={sidenavColor}
            onClick={handleSubmit}
          >
            Reserve Now
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PopAddReservation;
